import { useContext } from "react";
import { globalContext } from "../../global/Store";
import config from "../../config/Config.json";
import { ApplicantReferral, Applicant } from "../../global/Types";
import { GetMockApplicantRead } from "../../mock/applicant/ApplicantRead";
import { GetMockApplicantList } from "../../mock/applicant/ApplicantList";

export const useApplicantDataRepo = () => {
  const { globalState, dispatch, globalFunctions } = useContext(globalContext);

  const GetApplicant = (id: number) => {
    return new Promise(function (resolve, reject) {
      if (config.RunMode === "MOCK") {
        resolve(GetMockApplicantRead());
      } else {
        globalFunctions
          .CallPortalApi("Applicant/Read", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + globalState.user.token,
            },
            body: JSON.stringify({
              Id: id,
            }),
          })
          .then(
            function (response: any) {
              resolve(response);
            },
            function (error: any) {
              reject(error);
            }
          );
      }
    });
  };

  const GetApplicantList = (id: number) => {
    return new Promise(function (resolve, reject) {
      if (config.RunMode === "MOCK") {
        resolve(GetMockApplicantList());
      } else {
        globalFunctions
          .CallPortalApi("Applicant/List", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + globalState.user.token,
            },
            body: JSON.stringify({
              Id: id,
            }),
          })
          .then(
            function (response: any) {
              resolve(response);
            },
            function (error: any) {
              reject(error);
            }
          );
      }
    });
  };

  const CreateApplicant = (applicant: ApplicantReferral) => {
    return new Promise(function (resolve, reject) {
      if (config.RunMode === "MOCK") {
        resolve(GetMockApplicantList());
      } else {
        globalFunctions
          .CallPortalApi("Applicant/Create", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + globalState.user.token,
            },
            body: JSON.stringify(applicant),
          })
          .then(
            function (response: any) {
              resolve(response);
            },
            function (error: any) {
              reject(error);
            }
          );
      }
    });
  };

  const UpdateApplicant = (applicant: Applicant) => {
    return new Promise(function (resolve, reject) {
      if (config.RunMode === "MOCK") {
        resolve(GetMockApplicantList());
      } else {
        globalFunctions
          .CallPortalApi("Applicant/Update", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + globalState.user.token,
            },
            body: JSON.stringify(applicant),
          })
          .then(
            function (response: any) {
              resolve(response);
            },
            function (error: any) {
              reject(error);
            }
          );
      }
    });
  };

  return { GetApplicant, GetApplicantList, CreateApplicant, UpdateApplicant };
};
